import BrandImport from '../views/brandimport/Index.vue';
import { checkauth } from '../Helper';

function auth(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
	{
		path: '/brand-import',
		name: 'brand-import',
		component: BrandImport,
		beforeEnter: auth,
	},
	// impostazioni di import e regole di una marca (:id = _id della marca)
	{
		path: '/brand-import/brand/:id([0-9a-fA-F]{24})',
		name: 'brand-import-settings',
		component: () => import('../views/brandimport/Settings.vue'),
		beforeEnter: auth,
	},
	// prodotto trovato sul sito della marca (:id = _id del prodotto di Import da marchi)
	{
		path: '/brand-import/product/:id([0-9a-fA-F]{24})',
		name: 'brand-import-product',
		component: () => import('../views/brandimport/Product.vue'),
		beforeEnter: auth,
	},
];
